"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltiumImplementationList = void 0;
const SchDocTypes_1 = require("../SchDocTypes");
class AltiumImplementationList {
    constructor(schematic, record) {
        this.schematic = schematic;
        this.record = record;
    }
    getImplementations() {
        const children = this.schematic.getChildRecords(this.record.index);
        return children.filter((r) => r.recordType === SchDocTypes_1.RecordType.IMPLEMENTATION);
    }
    hasImplementations() {
        return this.getImplementations().length > 0;
    }
    getCurrentImplementation() {
        return this.getImplementations().find((impl) => impl.isCurrent);
    }
    hasCurrentImplementation() {
        return this.getCurrentImplementation() !== undefined;
    }
    getImplementationsByType(modelType) {
        return this.getImplementations().filter((impl) => impl.modelType === modelType);
    }
    getPcbLibImplementation() {
        return (this.getImplementationsByType('PCBLIB').find((impl) => impl.isCurrent) ??
            this.getImplementationsByType('PCBLIB')[0]);
    }
}
exports.AltiumImplementationList = AltiumImplementationList;
//# sourceMappingURL=AltiumImplementationList.js.map